<!--
 * @Descripttion: 广告机
 * @FilePath: /mall-wap-vue/src/views/poster/ad-machine/index.vue
 * @Author: 张兴业
 * @Date: 2021-07-13 16:37:13
 * @LastEditors: 张兴业
 * @LastEditTime: 2021-08-18 16:07:39
-->

<template>
  <div class="ad">
    <div class="content">
      <div class="info">
        <img :src="detail.storeAvatarUrl" class="storeAvatar" />
        <div class="storeName">{{ detail.storeName }}</div>
      </div>
      <div v-if="detail.linkUrl" class="qrcode_back">
        <qrcode-vue
          :size="440"
          :value="detail.linkUrl"
          level="H"
          class-name="qrcode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreInfoInAdMachine } from "@/api/poster.js";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    "qrcode-vue": QrcodeVue
  },
  data() {
    return {
      detail: {}
    };
  },
  mounted() {
    this.getStoreInfoInAdMachine();
  },
  methods: {
    getStoreInfoInAdMachine() {
      getStoreInfoInAdMachine({
        deviceNo: this.$route.query.uuid
      })
        .then(res => {
          if (res.code === 1) {
            this.detail = res.data;
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.ad {
  width: 100%;
  height: 100vh;

  .content {
    width: 100%;
    height: 100%;
    padding: 24px 36px;
    box-sizing: border-box;

    .info {
      display: flex;

      .storeAvatar {
        width: 64px;
        height: 64px;
        border-radius: 32px;
        display: block;
      }

      .storeName {
        margin: auto 12px;
        font-size: 20px;
        font-weight: 600;
      }
    }

    .qrcode_back {
      margin-top: 24px;
      text-align: center;
    }
  }
}
</style>
